<script>
    import { metaInfo } from "@/core/MetaInfo";
    import LookbookHero from "@xd/components/LookbookHero";
    import LookbookContent from "@xd/components/LookbookContent";
    import LookbookFooter from "@xd/components/LookbookFooter";

    export default {
        name: "Lookbook",
        components: { LookbookHero, LookbookContent, LookbookFooter },
        metaInfo() {
            return metaInfo.getMeta("lookbook");
        },
    };
</script>

<template>
    <div class="lookbook">
        <lookbook-hero></lookbook-hero>
        <lookbook-content></lookbook-content>
        <lookbook-footer></lookbook-footer>
    </div>
</template>

<style lang="scss"></style>
